import React from "react";
import { Link } from "react-router-dom";
import FooterLogo from "./FooterLogo";

const Footer = () => {
  return (
    <div className='bg-black'>
      <div
        className='pt-10 pb-6 bg-middle bg-center bg-no-repeat bg-[length:75px]'
        style={{ backgroundImage: "url('https://storage.googleapis.com/foodpop-marketing/homepage-assets/footer-icon.svg')" }}
      >
        <div className='flex justify-center items-center pt-20 pb-6'>
          <nav aria-label='Footer navigation'>
            <ul className='flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm'>
              <li><Link to='/about' className='text-gray-400 hover:text-white'>About</Link></li>
              <li><Link to='/pricing' className='text-gray-400 hover:text-white'>Pricing</Link></li>
              <li><Link to='/blog' className='text-gray-400 hover:text-white'>Blog</Link></li>
              <li><Link to='/contact' className='text-gray-400 hover:text-white'>Contact</Link></li>
              <li><Link to='/account/login' className='text-gray-400 hover:text-white'>Log in</Link></li>
              <li><Link to='/account/register' className='text-gray-400 hover:text-white'>Get started</Link></li>
            </ul>
          </nav>
        </div>
      </div>
      <div className='text-center pb-6'>
        <FooterLogo colour='white' />
      </div>
    </div>
  );
};

export default Footer;
